import { Checkbox as RadixCheckbox, Label } from "radix-ui";
import { CheckIcon, MinusIcon } from "lucide-react";
import { useId } from "react";
import styles from "./Checkbox.css";

interface CheckboxProps {
  label: string;
  name?: string;
  size?: "medium" | "small";
  disabled?: boolean;
  required?: boolean;
  checked?: boolean | "indeterminate";
  onCheckedChange?: (checked: boolean | "indeterminate") => void;
  error?: boolean;
}

const Checkbox = ({
  label,
  name,
  size = "medium",
  disabled = false,
  required = false,
  checked,
  onCheckedChange,
  error = false,
}: CheckboxProps) => {
  const id = useId();

  return (
    <div className={styles.container({ size })}>
      <RadixCheckbox.Root
        id={id}
        name={name}
        className={styles.root({ error })}
        disabled={disabled}
        required={required}
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-invalid={error}
        aria-required={required}
      >
        <RadixCheckbox.Indicator>
          {checked === "indeterminate" ? (
            <MinusIcon size="16px" />
          ) : (
            <CheckIcon size="16px" />
          )}
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <Label.Root htmlFor={id}>{label}</Label.Root>
    </div>
  );
};

export default Checkbox;
